import { useEffect, useRef, useState } from "react";

// SignalR messages the seller sends around the "Change price" dialog. The price
// itself is still saved through the unchanged ContractMain/Update call; these only
// tell a connected buyer to lock the page while it is being edited and to reload
// the price once it is saved.
export const PRICE_MSG = {
  changing: "Seller is changing price",
  updated: "Seller updated price",
  cancelled: "Seller cancelled price change",
};

const ALL = Object.values(PRICE_MSG);

// Returns true while the seller has the price dialog open. Calls onPriceUpdated
// once per new "updated" message (counted, so re-renders / later messages never
// re-fire it).
export default function useSellerPriceLock(messages, onPriceUpdated) {
  const [locked, setLocked] = useState(false);
  const seenUpdates = useRef(0);
  const callbackRef = useRef(onPriceUpdated);
  callbackRef.current = onPriceUpdated;

  useEffect(() => {
    const priceMsgs = messages.filter((m) => m.user === "seller" && ALL.includes(m.message));
    const last = priceMsgs[priceMsgs.length - 1];
    setLocked(last?.message === PRICE_MSG.changing);

    const updates = priceMsgs.filter((m) => m.message === PRICE_MSG.updated).length;
    if (updates < seenUpdates.current) seenUpdates.current = updates;
    if (updates > seenUpdates.current) {
      seenUpdates.current = updates;
      callbackRef.current?.();
    }
  }, [messages]);

  return locked;
}
